import { useState, useEffect } from "react"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./useAuth"

export type UserRole = 'admin' | 'moderator' | 'user'

export const useAdmin = () => {
  const { user } = useAuth()
  const [userRole, setUserRole] = useState<UserRole>('user')
  const [loading, setLoading] = useState(true)

  const fetchUserRole = async () => {
    if (!user) {
      setUserRole('user')
      setLoading(false)
      return
    }

    try {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .maybeSingle()

      if (error) throw error
      const role = data?.role || 'user'
      console.log('User role loaded:', role, 'for user:', user.id)
      setUserRole(role)
    } catch (error) {
      console.error('Error fetching user role:', error)
      setUserRole('user')
    } finally {
      setLoading(false)
    }
  }

  const isAdmin = () => userRole === 'admin'
  const isModerator = () => userRole === 'moderator' || userRole === 'admin'

  // Admin promotion removed for security - must be done via database with proper authorization

  useEffect(() => {
    fetchUserRole()
  }, [user])

  return {
    userRole,
    loading,
    isAdmin,
    isModerator,
    fetchUserRole
  }
}